import { render, staticRenderFns } from "./EmailChangeConfirmation.vue?vue&type=template&id=add852fe"
import script from "./EmailChangeConfirmation.vue?vue&type=script&lang=js"
export * from "./EmailChangeConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports